// extracted by mini-css-extract-plugin
export default {"presentationContainer":"presentation-container_presentationContainer__Gexlc","fullHeight":"presentation-container_fullHeight__TZaGQ"};